export default __webpack_public_path__ + "static/media/background.efde58d9.png";